module.exports = __webpack_public_path__ + "img/HomepageBannerHeader.5f8dda53.png";